"use client";

import dynamic from "next/dynamic";
import { useProfile } from "@/contexts/ProfileContext";

// Heavy admin panel + moderation/delete dialogs load lazily and only after the
// admin gate below, so the public profile bundle stays clean for regular
// visitors (none of this ships unless the viewer is an admin).
const ProfileAdminControlsInner = dynamic(
  () => import("./ProfileAdminControlsInner").then((m) => m.ProfileAdminControlsInner),
  { ssr: false },
);

/**
 * Admin-only control surfaced on a user's public profile (/store/[username]).
 * Renders nothing for non-admins. For admins it shows a "Manage user" button
 * that opens the full admin detail + moderation UI in place, so an admin can
 * inspect and manage any user without leaving for the admin hub.
 */
export function ProfileAdminControls({
  profileId,
  className,
}: {
  profileId: string | null | undefined;
  className?: string;
}) {
  const { isAdmin } = useProfile();
  if (!isAdmin || !profileId) return null;
  return <ProfileAdminControlsInner profileId={profileId} className={className} />;
}

export default ProfileAdminControls;
